import { withInstall } from '@tav-ui/utils/with-install'
import FileActionUpload from './index.vue'

export * from './types'
export const TaFileActionUpload = withInstall(FileActionUpload)
export default TaFileActionUpload
